export const ncKeys = {
  getSeverity: () => ["severity"] as const,
  getFailures: () => ["failures"] as const,
  getTransitions: () => ["transitions"] as const,
  getReworkCodes: (failureNIds: string[], materialNId?: string | null) =>
    ["reworkCodes", failureNIds, materialNId] as const,
  getNc: (nId: string) => ["nc", nId] as const,
  getNCFailures: (id: string) => ["ncFailures", id] as const,
  getNCMTUs: (id: string) => ["ncMTUs", id] as const,
};
